import { GET_ALL_AUDIT_LOG } from '@/types/auditLogTypes';

const actionTypes = [{ type: GET_ALL_AUDIT_LOG, key: 'getAllAuditLog' }];

let initialState = actionTypes.reduce((acc, { key }) => {
    acc[key] = false;
    acc[`err${key.charAt(0).toUpperCase() + key.slice(1)}`] = false;
    return acc;
}, {});

const auditLogSlice = (state = initialState, action) => {
    const acc = actionTypes.find((item) => item.type === action.type);
    if (!acc) return state;
    return {
        ...state,
        [acc.key]: action?.payload?.data,
        [`err${acc.key.charAt(0).toUpperCase() + acc.key.slice(1)}`]: action?.payload?.errorMessage
    };
};

export default auditLogSlice;
